<template>
  <v-btn
    class="mbtn font-weight-regular"
    prepend-icon="ct:arrow-left"
    @click="appraisalBuyoutStep -= 1"
  >
    {{ t("buyout.appraisal.go_back") }}
  </v-btn>
  <div class="app__title app__title--h3">
    {{ `${t("buyout.appraisal.choose")} ${selectedDeviceType?.name_singular} ${selectedManufacturer?.name} ${isNewDeviceProcess ? t("static.banners.for_buyout") : ''}` }}
  </div>
  <div class="app__form">
    <div class="formItem formItem--1x6 formItem--noLabel">
      <v-text-field
        v-model="search"
        :placeholder="t('buyout.appraisal.fast_model_search')"
        append-inner-icon="ct:magnifying-glass"
      />
    </div>
  </div>
  <v-progress-circular v-if="loadingMetaMasters" />
  <client-only v-else>
    <div :class="`buyout__cards buyout__cards--devices buyout__cards--${selectedDeviceType?.seo_name}`">
      <buyout-promo-box
        v-if="maxBuyoutBonus!==0 && !isNewDeviceProcess"
        :max-buyout-bonus="maxBuyoutBonus"
        :manufacturer-seo-name="selectedManufacturer!.seo_name"
        :partner-sub-brand="partnerSubBrand"
      />
      <div
        v-for="(availableMetaMaster, index) in filteredMetaMasters"
        :key="availableMetaMaster.id"
        :class="[
          'bCard bPicker__category',
          selectedMetaMaster === availableMetaMaster ? 'is-selected' : '', 'cursor-pointer',
        ]"
        :style="`order: ${index}`"
        @click="selectMetaMaster(availableMetaMaster)"
      >
        <img :src="buildImageUrl(availableMetaMaster?.image)" class="img-responsive">
        <div class="bPicker__desc">
          <div class="font-weight-semibold">
            {{ availableMetaMaster.name }}
          </div>
          <div class="bPicker__price color--greenTone1 font-medium">
            {{ t("buyout.common.to") }} <span class="text-no-wrap font-weight-bold">{{ useCurrency(availableMetaMaster.max_buyout_price) }}</span>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" content-class="popup aScroll">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          class="mbtn mbtn--trans mbtn--multiline"
          size="x-large"
        >
          {{ `${t("buyout.common.you_havent_found")} ${getTranslation} ${selectedDeviceType?.name_singular}` }}?
        </v-btn>
      </template>
      <nuxt-link
        class="popup__close cursor-pointer"
        @click="dialog = !dialog"
      >
        <v-icon icon="ct:cross" size="x-small" />
      </nuxt-link>
      <auth-contact-form
        :subject="(`${t('buyout.common.didnt_find')} ${getTranslation} ${selectedDeviceType?.name_singular}?`)"
        @close-dialog="dialog = false"
      />
    </v-dialog>
  </client-only>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import useCurrency from "cashtec-common/src/composables/useCurrency";

const { buildImageUrl } = useUtils();
const buyoutStore = useBuyoutStore();
const { t } = useI18n();

const {
  selectedMetaMaster,
  selectedDeviceType,
  selectedManufacturer,
  appraisalBuyoutStep,
  availableMetaMasters,
  loadingMetaMasters,
  maxBuyoutBonus,
  partnerSubBrand
} = storeToRefs(buyoutStore);

const search = ref<string>("");
const bonusPartnerWithManufacturerBuyoutStore = useBonusPartnerWithManufacturerBuyoutStore();

const componentProps = withDefaults(defineProps<{
  isNewDeviceProcess?: boolean
}>(), {
  isNewDeviceProcess: false
});

const filteredMetaMasters = computed<BuyoutMetaMaster[] | []>(() => {
  return availableMetaMasters.value.filter((master) => {
    return master.name.toLowerCase().includes(search.value.toLowerCase());
  });
});

if (!availableMetaMasters.value.length) {
  buyoutStore.loadAvailableMetaMasters();
}

const getTranslation = computed<string>(() => {
  if (selectedDeviceType?.value && (["telefony", "tablety", "notebooky", "foto", "objektivy", "reproduktory"].includes(selectedDeviceType.value.seo_name))) {
    return t("buyout.appraisal.your_case_first");
  }
  return t("buyout.appraisal.your_case_second");
});

async function selectMetaMaster (metaMaster: BuyoutMetaMaster) {
  if (selectedMetaMaster.value !== metaMaster) {
    selectedMetaMaster.value = metaMaster;
    buyoutStore.resetProductVariant();
    if(componentProps.isNewDeviceProcess) {
      await bonusPartnerWithManufacturerBuyoutStore.changeURLNewDevice();
    } else {
      await buyoutStore.changeURL();
    }
  }
  if (buyoutStore.hideMetaMasterStep) {
    await buyoutStore.loadAvailableProductVariants();
    await buyoutStore.selectProductVariant(buyoutStore.availableProductVariants!.attr_values[0]);
    await buyoutStore.selectProductColor(buyoutStore.availableProductColors[0]);
    appraisalBuyoutStep.value += 2;
  } else {
    appraisalBuyoutStep.value += 1;
  }
}

const dialog = ref<boolean>(false);

</script>
